import { Button } from '@factorialco/deprecated-design-system'
import {
  DeleteProjectManagementRateDocument,
  DeleteProjectManagementRateMutation,
  JobsAndRatesDataCollectionDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import i18n from 'modules/core/lib/i18n'

interface DeleteRoleModalProps {
  onClose: () => void
  rateId: string
}

const DeleteRoleModal = ({ onClose, rateId }: DeleteRoleModalProps) => {
  const [deleteJobRoleRate, { loading }] = useMutation(DeleteProjectManagementRateDocument, {
    extractorFn: (mutationData: DeleteProjectManagementRateMutation) =>
      mutationData.projectManagementMutations.deleteProjectmanagementRate,
    awaitRefetchQueries: true,
    refetchQueries: [JobsAndRatesDataCollectionDocument],
  })

  const onSubmit = () => {
    deleteJobRoleRate({ variables: { id: rateId } })
    onClose()
  }

  return (
    <Modal
      illustration={'alert'}
      title={i18n.t('project_management.jobs_and_rates.delete_modal.title')}
      description={i18n.t('project_management.jobs_and_rates.delete_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={() => onClose()}>
            {i18n.t('common.back')}
          </Button>
          <Button submit onClick={onSubmit} disabled={loading}>
            {i18n.t('common.confirm')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default DeleteRoleModal
